import { useTranslation } from "Providers/TranslationProvider";

export enum CalendarType {
	DAY,
	WEEK,
	MONTH,
}

export function useTranslateCalendarType() {
	const { t } = useTranslation();

	return (calendarType: CalendarType) => {
		switch (calendarType) {
			case CalendarType.DAY:
				return t("CalendarNavigationHelper_CalendarType_Day");
			case CalendarType.WEEK:
				return t("CalendarNavigationHelper_CalendarType_Week");
			case CalendarType.MONTH:
				return t("CalendarNavigationHelper_CalendarType_Month");
		}
	};
}
